import {RootState} from '@reduxjs/toolkit/query';

// eslint-disable-next-line no-restricted-imports
import {path} from 'ramda';

export const getSubscriptionId = (state: RootState<any, any, 'rtk_omneticApi'>) => {
  const currentUserId = path<string>(
    ['rtk_omneticApi', 'queries', 'getCurrentUserInfo(undefined)', 'data', 'id'],
    state
  );
  return `${currentUserId || 'general'}-appsync-subscription`;
};
